<template>
    <router-view />
</template>

<script setup lang="ts">
    import { onMounted, provide } from "vue";
    import { useFw4Store } from "fw4-library";

    const { ShowReport } = useFw4Store();

    provide("showReport", ShowReport);
</script>
